import React from 'react';
import ColorPicker from './ColorPicker';
import './FormSection.css';

const FormSection = ({ 
  title, 
  description, 
  icon, 
  fields = [], 
  formData, 
  onFieldChange,
  className = '',
  disabled = false 
}) => {
  const handleFieldChange = (fieldName, value) => {
    if (onFieldChange) {
      onFieldChange(fieldName, value);
    }
  };

  return (
    <div className={`form-section ${className}`}>
      <div className="form-section-header">
        <div className="form-section-title">
          <span className="form-section-icon">{icon}</span>
          <h3 className="form-section-title-text">{title}</h3>
        </div>
        {description && (
          <p className="form-section-description">{description}</p>
        )}
      </div>
      
      <div className="form-section-content">
        {fields.map((field, index) => (
            <div key={field.name || index} className="form-field-group">
              {field.type === 'color' ? (
                <ColorPicker
                  label={field.label}
                  value={formData[field.name]}
                  onChange={(value) => handleFieldChange(field.name, value)}
                  placeholder={field.placeholder}
                  description={field.description}
                  cssVariables={field.cssVariables}
                  disabled={disabled}
                  className={field.className}
                />
              ) : field.type === 'text' ? (
              <div className="form-field">
                <label className="form-field-label">
                  {field.label}
                  {field.description && (
                    <span className="form-field-description">{field.description}</span>
                  )}
                </label>
                <input
                  type="text"
                  value={formData[field.name] || ''}
                  onChange={(e) => handleFieldChange(field.name, e.target.value)}
                  placeholder={field.placeholder}
                  disabled={disabled}
                  className="form-field-input"
                />
              </div>
            ) : field.type === 'textarea' ? (
              <div className="form-field">
                <label className="form-field-label">
                  {field.label}
                  {field.description && (
                    <span className="form-field-description">{field.description}</span>
                  )}
                </label>
                <textarea
                  value={formData[field.name] || ''}
                  onChange={(e) => handleFieldChange(field.name, e.target.value)}
                  placeholder={field.placeholder}
                  disabled={disabled}
                  className="form-field-textarea"
                  rows={field.rows || 3}
                />
              </div>
            ) : field.type === 'checkbox' ? (
              <div className="form-field form-field-checkbox">
                <label className="form-field-checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData[field.name] || false}
                    onChange={(e) => handleFieldChange(field.name, e.target.checked)}
                    disabled={disabled}
                    className="form-field-checkbox-input"
                  />
                  <span className="form-field-checkbox-text">
                    {field.label}
                    {field.description && (
                      <span className="form-field-description">{field.description}</span>
                    )}
                  </span>
                </label>
              </div>
            ) : field.type === 'select' ? (
              <div className="form-field">
                <label className="form-field-label">
                  {field.label}
                  {field.description && (
                    <span className="form-field-description">{field.description}</span>
                  )}
                </label>
                <select
                  value={formData[field.name] || ''}
                  onChange={(e) => handleFieldChange(field.name, e.target.value)}
                  disabled={disabled}
                  className="form-field-select"
                >
                  {field.options?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            ) : field.type === 'custom' ? (
              <div className="form-field">
                {field.component && field.component({
                  value: formData[field.name],
                  onChange: (value) => handleFieldChange(field.name, value),
                  disabled,
                  ...field.props
                })}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormSection;
